import { createTheme } from '@mui/material/styles';
import colors from './colors';

export const theme = createTheme({
  components: {
    MuiListItemButton: {
      styleOverrides: {
        root: {
          '&.Mui-selected': {
            backgroundColor: colors.neutralGrey300,
            borderRadius: 6,
          },
        },
      },
    },
  },
});

export { default as colors } from "./colors";
export * from "./sxFont";
export * from "./sxButton";
export * from "./sxTextField";
export * from "./sxSettingTextField";
